import React, { useState, useEffect } from 'react';
import './App.css';
import logo from './assets/images/logo.png'
import eye from './assets/images/eye.png'
import noeye from './assets/images/noeye.png'
import fblogo from './assets/images/f-Logo_White.png'
import { Form, Row, Col, Modal, Button } from 'react-bootstrap';
import { Config } from './config';
import { userLoginFetch, userFetch, userLogoutFetch, getCardsFetch, getCreditCardInfo, checkForPromo, buyPromoTicket } from "./lib/fetch";
import Cookies from 'universal-cookie';
import moment from 'moment';
import { isBrowser, isMobile } from "react-device-detect";
let cookies = new Cookies();

//App level settings
const test = Config.test;
const host = Config.preprod ? 'https://user-preprod.mypass.ski/main/#' : test ? 'https://user-test.mypass.ski/main/#' : 'https://user.mypass.ski/main/#';
const reg_url = host + '/signup';
const resetPass_url = host + '/resend-password';
const setPass_url = host + '/resend-password?set_pass';


function App() {
  /**@Hooks */

  //gets the windows size
  const size = useWindowSize();
  const screenClass = isMobile ? "bg-mob" : size.width>1907 ? "bg-web-full":"bg-web"; //set background image according the device

  //set fontSize for mobile and browser
  const size1 = isMobile ? '2em':'1.625em';
  const size2 = isMobile ? '2em':'1.375em';
  const size3 = isMobile ? '2em':'1.256em';
  const size4 = isMobile ? '2.5em':'1.455em';

  // first parameter is constant which can be assigned by the second one which is the function and the useState( initialize value )
  const [seePassword, setSeePassword] = useState(false);    //show and hide the password
  const [email, setEmail] = useState(null);   //set the email for the user log in
  const [password, setPassword] = useState(null); // set the password
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));  //set the local storage for getting the user assigned the user
  const [skiers, setSkiers] = useState([]); //
  const [show, setShow] = useState(false);
  const [alertParams, setAlertParams] = useState({});
  const [alertMode, setAlertMode] = useState(null);
  const [ccPan, setCCPan] = useState('');
  const [ticketNum, setTicketNum] = useState(0);
  const [skierProfile, setSkierProfile] = useState([]);
  const [expireSkiCards, setExpireSkiCards] = useState([]);

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // getting list of skiers
    if (user) {
      checkUserCC(user.access_token);
    }
  }, []);

  // functions and APIs
  // login
  function login(e) {
    //if user is loged in by another app, there is no need for login 
    if(user)window.location.reload();
    let params = {
      email: email,
      password: password,
    }
    console.log(params);
    userLoginFetch(params).then((response) => {
      console.log('Login @response: ', response);
      if (response.status === "success") {cookies.set("access_token", response.access_token);return getUserInfo(response.access_token);}
      localStorage.clear();
      cookies.remove('access_token');
      setAlertMode('info');
      setAlertParams({
        message: response.message ? response.message : "Errore di sistema. Contatta l’assistenza."
        , buttonCaption: "RIPROVA"
      });
      setShow(true);
      return;
    })
  }

  // submitting
  function onFormSubmit(e) {
    e.preventDefault();
    login();

  }
  //getting and storing all user info
  function getUserInfo(access_token) {
    console.log("userLoginFetch: !!Success!!:access_token  ", access_token);
    userFetch(access_token, {}
    ).then((response) => {
      console.log("getUserInfo: !!Success!!:", response);
      if (response.status === 'success') {
        localStorage.setItem('user', JSON.stringify(response.user));
        return window.location.reload();
      }
      localStorage.clear();
      cookies.remove('access_token');
      return;
    });
  }

  function checkUserCC(access_token) {
    getCreditCardInfo(access_token, {})
      .then((response) => {
        console.log("getCreditCardInfo @response: ", response);
        if (response.id_ut) {
          if (isCreditCardExpired(response.scadenza_contratto)) {
            showCCerrorAlert();
          }
          if (response.attiva == 1) {
            setCCPan(response.pan);
            getPromo();
          } else {
            showCCerrorAlert();
          }
        } else {
          showCCerrorAlert();
        }
      });
  }


  function showCCerrorAlert() {
    setAlertMode('noCCfound');
    setAlertParams({
      message: "Non è presente una carta di credito valida nel tuo account, per procedere con l’acquisto dei biglietti promozionali accedi alla tua Area Utente ed inserisci una nuova carta.",
      buttonCaption1: "PROCEDI", buttonCaption2: "ANNULLA"
    });

    setShow(true);
  }
  function showNoSkiCardAlert() {
    setAlertMode('noCCfound');
    setAlertParams({
      message: "Per usufruire della promozione è necessario avere almeno una card associata. Accedi alla tua Area Utente ed aggiungi la card.",
      buttonCaption1: "VAI ALL'AREA UTENTE", buttonCaption2: "ANNULLA"
    });

    setShow(true);
  }


  function showCreatePassForFbUser(e) {
    e.preventDefault()
    setAlertMode('createPassForFbUser');
    setAlertParams({message: "Per usufruire della Promo Black Friday di Bormio devi impostare la tua password ", buttonCaption1: "CREARE PASSWORD", buttonCaption2: "ANNULLA"});

    setShow(true);
  }


  function isCreditCardExpired(date) {
    console.log(date);
    var d1 = new Date();
    var d2 = new Date(date);
    console.log("date ", d1.getFullYear(), d1.getMonth(), d2.getFullYear(), d2.getMonth());
    let expired = (d1.getFullYear() > d2.getFullYear()) || (d1.getFullYear() == d2.getFullYear()) && (d1.getMonth() > d2.getMonth())
    return expired;
  }


  //logout and clear history and storage
  function logout(e) {
    if (e) e.preventDefault();
    try {
      // fill storage w/ user data.
      userLogoutFetch(user.access_token, {}).then((response) => {
        console.log(response);
        localStorage.clear();
        cookies.remove('access_token');
        setUser(null);
        return window.location.reload();
      });
    } catch (e) {
      console.log(e);
    }
  }


  //get all user's skiers
  function getSkiers() {
    getCardsFetch(user.access_token, {}).then((response) => {

      console.log('GETCARDS : ', response);
      if (typeof response === "undefined") return;
      if (response.length > 0) {
        let filterdResponse = response.filter((x)=>{return x.provider != "axess"});
        for (let index = 0; index < filterdResponse.length; index++) {
          setSkierProfile(skierProfile => [...skierProfile, 0]);
        }
        if (filterdResponse.length > 0) return setSkiers(filterdResponse);
        return showNoSkiCardAlert();
      }
    });
  }

  /**
   * 
   * @param {*} e 
   */
  function onPurchase(e) {
    e.preventDefault();
    console.log('onpyrchase');
    setAlertMode('paymentConfirm');
    setAlertParams(
      { message: `Ti saranno addebitati sulla carta di credito n° ${ccPan} l’importo di € ${ticketNum * Config.servicePrice},00`, buttonCaption1: "ACQUISTA", buttonCaption2: "ANNULLA" }
    );
    setShow(true);
  }

  function onPurchaseConfirmed() {
    console.log('onPurchaseConfirmed');
    setShow(false);

    let linked_users = [];

    skierProfile.forEach((el, index) => {
      if (el > 0) {
        linked_users.push({
          "linked_user_id": skiers[index].id.toString(),
          "quantity": el.toString()
        })

        // check if service is expired by 06/01/2020
        const isAfter = moment(skiers[index].data_scadenza, "YYYY,MM,DD").isAfter(moment("2020-01-06", "YYYY,MM,DD"));
        const isEqual = skiers[index].data_scadenza == "2020-01-06";

        let isValid = isAfter || isEqual;
        console.log("isValid", isValid);

        if (!isValid) {
          let exp_cards = expireSkiCards;
          exp_cards.push(skiers[index]);
          setExpireSkiCards(exp_cards);
        }
      }
    });

    console.log(linked_users, expireSkiCards);

    let tickets = {
      "resort_id": "2",
      "linked_users": linked_users
    }

    buyPromoTicket(user.access_token, { tickets: tickets })
      .then((response) => {
        console.log("buyPromoTicket @response: ", response);
        if (response.status === 'success') {
          switch (expireSkiCards.length) {
            case 0:
              setAlertMode('purchaseDoneOk');
              setAlertParams(
                { title: "Pagamento effettuato con successo!", message: "Le tue giornate sci promozionali saranno applicate automaticamente." }
              );
              setShow(true);
              break;
            case 1:
              setAlertMode('noActiveUserFound');
              setAlertParams(
                { title: "Pagamento effettuato con successo!", message: "Le tue giornate sci promozionali saranno applicate automaticamente.", msgBold: `Ti segnaliamo che l’utente ${expireSkiCards[0].name} ${expireSkiCards[0].surname} non ha il servizio MyPass Attivo. `, msgNormal: "L’attivazione deve essere effettuata nell’area utente per accedere alle piste.", buttonCaption1: "OK", buttonCaption2: "RINNOVA SERVIZIO" }
              );
              setShow(true);
              break;
            default:
      
              let strNames = "";
              for (let index = 0; index < expireSkiCards.length; index++) {
                const element = expireSkiCards[index];
      
                strNames += (index !== 0 ? 'e ' : '') + element.name + ' ' + element.surname + ' ';
      
              }
              setAlertMode('noActiveUserFound');
              setAlertParams(
                { title: "Pagamento effettuato con successo!", message: "Le tue giornate sci promozionali saranno applicate automaticamente.", msgBold: `Ti segnaliamo che gli utenti ${strNames} non hanno il servizio MyPass Attivo. `, msgNormal: "L’attivazione deve essere effettuata nell’area utente per accedere alle piste.", buttonCaption1: "OK", buttonCaption2: "RINNOVA SERVIZIO" }
              );
              setShow(true);
              break;
          }
        } else {
          setAlertMode('info');
          setAlertParams({
            message: response.message ? response.message : "Errore di sistema. Contatta l’assistenza."
            , buttonCaption: "OK"
          });
          setShow(true);
          return;
        }
      });


  }


  function getPromo() {
    checkForPromo(user.access_token, {})
      .then((response) => {
        console.log("checkForPromo @response: ", response);

        if (response.status === 'success') {
          const skiers = response.skiers;
          const skiersWitPromo = skiers.filter(function (x) {
            return x.available < 2;
          })
          console.log('skiersWitPromo', skiersWitPromo);

          if (skiersWitPromo.length > 0) {
            setAlertMode('noPromo');
            setAlertParams(
              { message: "Hai già aderito alla promozione Bormio!", buttonCaption: "OK" }
            );
            setShow(true);
            return;
          }
          getSkiers();

        }else{
          //user has no card
          showNoSkiCardAlert();
        }
      });
  }

  function onticketNumberChanged(e, index) {
    console.log(e.target.value, index);
    let sp = skierProfile;
    sp[index] = Number(e.target.value);
    setSkierProfile(sp);
    console.log('skierProfile', skierProfile);
    setTicketNum(
      sp.reduce(function (acc, el) {
        return acc + el;
      })
    )
    console.log('ticketNum', ticketNum);

  }
function onCreateNewPassClicked() {
  setShow(false);
  checkforLogin();
  window.open(setPass_url,'_blank');

  
}
function checkforLogin() {
  var loginTimer= setInterval(() => {
    console.log('interval triggred!');
    if (localStorage.getItem('user'))window.location.reload();
  }, 2000);
}
  return (
    <Form className={screenClass} onSubmit={onFormSubmit}>

      <div className="d-flex justify-content-center">
        <img src={logo} className="logo" alt="mypass ski logo" />
      </div>
      <div style={{paddingLeft: isMobile? '3em':'10em'}} className="spaceLeft">
        <p style={{ marginTop: "1.75em", fontSize: size1 }} className="text-left in-esclusiva-per-i-c (--header-color: #ff4545)">In esclusiva per i clienti MyPass Ski</p>
        <p style={{ marginTop: "0.2em" }} className="text-left black-friday-bormio">Black Friday Bormio</p>
        <p style={{ marginTop: "0.02em" }} className="trentanove-€-invece-di-44-€">39€ invece di 44€</p>
        <p style={{ marginTop: "0.0000005em" }} className="sullo-skipass-giorna">sullo skipass giornaliero adulto</p>
        <p style={{fontSize: size2 }} className="fino-alle-23-59-del">Fino alle 23:59 del 23 Dicembre.</p>
        <p style={{fontSize: size3 }} className="massimo-2-biglietti">• Massimo 2 biglietti per sciatore valido dal 21/12/2019 al 06/01/2020 al prezzo di 39€</p>
        <p style={{fontSize: size3 }} className="promozione-applicata">• Promozione applicata al primo accesso fatto nel periodo di validità</p>
        <p style={{fontSize: size3 }} className="valida-solo-a-bormio">• Valida solo a Bormio</p>
        <p hidden={user} style={{fontSize: size4, marginTop: "1em" }} className="accedi-per-avere-gli">Accedi per avere gli sconti</p>
        <Row hidden={!user} style={{ fontSize: isMobile?'2em': '1.455em', marginTop: "1em" }} className="accedi-per-avere-gli2">
          <Col className="col-md-auto">{"scegli i tuoi skipass".toUpperCase()}</Col>
          <Col style={{ fontWeight: 'normal',  fontSize:isMobile? 30:16, paddingTop: 5, marginLeft: isMobile? '-1em':'5em' }} className="col-md-auto utente-mario-rossi">Utente: {user ? user.name : ''} {user ? user.surname : ''} {'. '}</Col>
          <Col onClick={(e) => logout(e)} style={{ fontWeight: 'normal', fontSize:isMobile? 30:16, paddingTop: 5,marginLeft:isMobile? '-1em':0 }} className="col-md-auto logout">Logout</Col>
        </Row>

      </div>

      {/* loginpanel */}
      <div hidden={user} style={{ marginTop: "1em", marginLeft: "9em", paddingBottom: "5em" }}>
        <div className={isMobile?"mask-mob":"mask"} onSubmit={onFormSubmit}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label style={{ marginTop: "1.5em",fontSize:isMobile?"3em":"" }} className="emailPassTitle">Email</Form.Label>
            <Form.Control onChange={(e) => setEmail(e.target.value)} style={{ width: '90%', borderWidth: 0, backgroundColor: 'transparent', borderBottomWidth: '0.2em', borderBottomColor: '#666666', borderRadius: 0, padding: 0, fontSize:isMobile?'3em':'1em' }} type="email" placeholder="user@mail.com" />
          </Form.Group>
          <Form.Group controlId="formBasicPassword">
            <Form.Label style={{ fontSize:isMobile?"3em":"", marginTop: "1.5em" }} className="emailPassTitle">Password</Form.Label>
          </Form.Group>
          <div>
            <img onClick={() => setSeePassword(!seePassword)} src={seePassword ? noeye: eye} style={{ width:isMobile?'3.6em': '2.2em', height:isMobile?'3.0em':  '1.5em', position: 'absolute', marginLeft: isMobile? '44em':'31em' }} alt="mypass ski logo" />
            <Form.Control onChange={(e) => setPassword(e.target.value)} style={{ width: '90%', borderWidth: 0, backgroundColor: 'transparent', borderBottomWidth: '0.2em', borderBottomColor: '#666666', borderRadius: 0, padding: 0 , fontSize:isMobile?'3em':'1em'}} type={seePassword ? "text" : "password"} placeholder="Password" />
          </div>
          <Form.Text style={{ marginTop: "1.5em", fontSize: isMobile?"2em":"1em" }} className="password-dimenticata"><a  target="_blank" href={resetPass_url} style={{ color: 'black' }}>Password dimenticata?</a></Form.Text>
          <button style={{ marginTop: "2em", marginLeft:isMobile?'3em':'7em', width:isMobile? '40em': '20em', height:isMobile?'6em':'3em' }} className="acquista" type="submit"><p style={{ fontSize:isMobile? '3em': '1.4em', paddingTop: '0.17em' }}>Accedi</p></button>
          <button onClick={(e)=>showCreatePassForFbUser(e)} style={{ marginTop: "1em", marginLeft:isMobile?'3em':'7em', width:isMobile? '40em': '20em', height:isMobile?'6em':'3em' }} className="fbbtn">
            <p style={{ fontSize:isMobile? '2.5em': '1.1em', paddingTop: '0.5em' }}><img src={fblogo} style={{ width:isMobile?'0.8em': '1em', height:isMobile?'1.2em':  '2em', marginRight:'0.5em'}}/> Accedi con Facebook</p></button>
          <Form.Text style={{ marginTop: isMobile?"1em":"2em", marginLeft:isMobile? '5%':'15%', fontSize:size2 }} className="non-sei-ancora-nostr">Non sei ancora nostro cliente? <u className="reg"><a target="_blank" href={reg_url} style={{ color: 'black' }}>Registrati</a></u></Form.Text>
        </div>
          <div className="text-center">
                    <small>Copyright © MyPass 2019 - version: {Config.version} </small>
                </div>
      </div>

      {/* Logged in user */}
      <div hidden={!user} style={{ marginTop: "1em", marginLeft: "9em", paddingBottom: "5em" }}>
        <div className={isMobile? "mask_loggedin-mob":"mask_loggedin"} onSubmit={onFormSubmit}>

          {/* rendering list of skiers */}

          {
            skiers.map((skier, index) => {
              const tPriceText = `€ ${skierProfile[index] * Config.servicePrice},00`;
              const disabled = (skier.provider.toLowerCase() !== 'skidata' || skier.type.toLowerCase() !== 'adult');
              return (
                <div className="skierContainer" key={"skier+" + index} style={{ color: disabled ? 'rgba(0,0,0,0.25)' : '' }}>
                  <div style={{ flex: 0.15 }}>
                    <select onChange={(e) => onticketNumberChanged(e, index)} disabled={disabled} className="dropdown" style={{ 	height:isMobile?'4em': '2em', width:isMobile?'6em':  '4em',borderColor: disabled ? 'rgba(0,0,0,0.25)' : '' }}>
                      <option value={0}>0</option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                    </select>
                  </div>
                  <div style={{ flex: 0.75 }}>
                    <p style={{ color: disabled ? 'rgba(0,0,0,0.25)' : '', fontSize: isMobile?'2em':'1em' }} className="cardowner">{skier.name + ' ' + skier.surname}</p>
                    <p style={{ color: disabled ? 'rgba(0,0,0,0.25)' : '' , fontSize: isMobile?'2em':'1em'}} className="cardnumber">{skier.code ? skier.code : 'nessuna carta attiva'}</p>
                  </div>
                  <div style={{ flex: isMobile?0.15: 0.1 , fontSize: isMobile?'2em':'1em'}}><p>{tPriceText}</p></div>
                </div>
              )
            })
          }

          <hr className={isMobile? "line-2-copy-mob": "line-2-copy"} />
          <div className={isMobile? "priceContainer-mob": "priceContainer"} style={{ width:isMobile?'23em': '44em' }}>
            <p >TOTALE</p>
            <p >€ {ticketNum * Config.servicePrice},00</p>
          </div>
          <button disabled={ticketNum === 0} style={{  marginLeft:isMobile?'3em':'12em', width:isMobile? '40em': '20em', height:isMobile?'6em':'3em',marginTop: "2em", backgroundColor: ticketNum === 0 ? 'rgb(91, 230, 255, 0.5)' : '', color: ticketNum === 0 ? 'white' : '' }} className="acquista" onClick={(e) => onPurchase(e)}><p style={{ fontSize:isMobile? '3em': '1.4em', paddingTop: '0.17em', color:ticketNum === 0? 'rgba(0,0,0,0.5)':'rgba(0,0,0)' }}>Procedi all'acquisto</p></button>
        </div>
      </div>
      <PopUp mode={alertMode} params={alertParams} />
    </Form>
  );

  //popups
  function PopUp({ mode, params }) {
    /*
    mode: 
          info: single+discription(optional) line in bold with single button //{message: "Hai già aderito alla promozione Bormio!", buttonCaption: "OK"}
          noCCfound: one line info in bold buttons: PROCEDI(goes to user area), ANNULLA//{message: "Hai già aderito alla promozione Bormio!", buttonCaption1: "PROCEDI", buttonCaption2: "ANNULLA"}
          paymentConfirm: one line info in bold buttons: ACQUISTA(makes the payment), ANNULLA//{message: "Hai già aderito alla promozione Bormio!", buttonCaption1: "ACQUISTA", buttonCaption2: "ANNULLA"}
          noActiveUserFound: title in bold+nextline+space+description:bold+normal: OK, RINNOVA SERVIZIO(goes to user area)//{ title: "Pagamento effettuato con successo!", message: "Le tue giornate sci promozionali saranno applicate automaticamente.", msgBold: "Ti segnaliamo che gli utenti Mario Rossi e Giulia White non hanno il servizio MyPass Attivo. ", msgNormal: "L’attivazione deve essere effettuata nell’area utente per accedere alle piste.", buttonCaption1: "OK", buttonCaption2: "RINNOVA SERVIZIO" }
          purchaseDoneOk: single line in bold+discription : OK (logout)//{ title: "Pagamento effettuato con successo!", message: "Le tue giornate sci promozionali saranno applicate automaticamente." }
    */
    const gotoHome = () => window.open(host,'_blank');
    const handleClose = () => setShow(false);
    const InfoModal =
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{params.message}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={handleClose}>
            {params.buttonCaption}
          </Button>
        </Modal.Footer>
      </Modal>

    const NoPromo =
      <Modal show={show} onHide={logout}>
        <Modal.Header closeButton>
          <Modal.Title>{params.message}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={logout}>
            {params.buttonCaption}
          </Button>
        </Modal.Footer>
      </Modal>

    const NoCCfound =
      <Modal show={show} onHide={logout}>
        <Modal.Header closeButton>
          <Modal.Title>{params.message}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={gotoHome}>
            {params.buttonCaption1}
          </Button>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={logout}>
            {params.buttonCaption2}
          </Button>
        </Modal.Footer>
      </Modal>

    const PaymentConfirm =
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{params.message}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={onPurchaseConfirmed}>
            {params.buttonCaption1}
          </Button>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={handleClose}>
            {params.buttonCaption2}
          </Button>
        </Modal.Footer>
      </Modal>

const CreatePassForFbUser =
<Modal show={show} onHide={handleClose}>
  <Modal.Header closeButton>
    <Modal.Title>{params.message}</Modal.Title>
  </Modal.Header>
  <Modal.Footer>
    <Button className="type-something" size="lg" variant="outline-dark" onClick={onCreateNewPassClicked}>
      {params.buttonCaption1}
    </Button>
    <Button className="type-something" size="lg" variant="outline-dark" onClick={handleClose}>
      {params.buttonCaption2}
    </Button>
  </Modal.Footer>
</Modal>      

    const NoActiveUserFound =
      <Modal show={show} onHide={logout}>
        <Modal.Header closeButton>
          <Modal.Title>{params.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{params.message}</Modal.Body>
        <Modal.Body><b>{params.msgBold}</b>{params.msgNormal}</Modal.Body>
        <Modal.Footer>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={logout}>
            {params.buttonCaption1}
          </Button>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={gotoHome}>
            {params.buttonCaption2}
          </Button>
        </Modal.Footer>
      </Modal>

    const PurchaseDoneOk =
      <Modal show={show} onHide={logout}>
        <Modal.Header closeButton>
          <Modal.Title>{params.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{params.message}</Modal.Body>
        <Modal.Footer>
          <Button className="type-something" size="lg" variant="outline-dark" onClick={logout}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

    return (
      (mode === 'info') ?
        InfoModal
        :
        (mode === 'noCCfound') ?
          NoCCfound
          :
          (mode === 'paymentConfirm') ?
            PaymentConfirm
            :
            (mode === 'noActiveUserFound') ?
              NoActiveUserFound
              :
              (mode === 'purchaseDoneOk') ?
                PurchaseDoneOk
                :
                (mode === 'noPromo') ?
                  NoPromo
                  :
                  (mode === 'createPassForFbUser') ?
                  CreatePassForFbUser
                  :                  
                  <></>
    );
  }


  function useWindowSize() {
    const isClient = typeof window === 'object';
  
    function getSize() {
      return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined
      };
    }
  
    const [windowSize, setWindowSize] = useState(getSize);
  
    useEffect(() => {
      if (!isClient) {
        return false;
      }
      
      function handleResize() {
        setWindowSize(getSize());
      }
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
  }  
}
export default App;
